// extracted by mini-css-extract-plugin
export default {"root":"Tile_root__zwUla","title":"Tile_title__3UI9t"};